// A tab left open across a deploy (the projector's MANAGER screen, a
// tablet...) keeps running the old bundle against the new server - and
// silently misses whatever the new version added. The built index.html names
// the app bundle by content hash, so a different name is a different build.
const BUNDLE = /\/js\/app\.[0-9a-f]+\.js/;

export function loadedBundle(doc = globalThis.document) {
    for (const script of doc.scripts || []) {
        const match = (script.src || '').match(BUNDLE);
        if (match) return match[0];
    }
    return null;
}

export async function servedBundle(fetchFn = globalThis.fetch) {
    const response = await fetchFn('/index.html', { cache: 'no-store' });
    if (!response.ok) return null;
    const match = (await response.text()).match(BUNDLE);
    return match ? match[0] : null;
}

// false whenever it can't tell (dev server bundles have no hash, network
// errors) - a needless reload mid-event is worse than a missed one.
export async function isOutdated({ fetch = globalThis.fetch, document = globalThis.document } = {}) {
    const loaded = loadedBundle(document);
    if (!loaded) return false;
    try {
        const served = await servedBundle(fetch);
        return !!served && served !== loaded;
    } catch (error) {
        return false;
    }
}
